import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'
import ja from './ja'
import './styles/index.scss'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    default: 'light',
    themes: {
      light: {
        primary: colors.blue.darken2,
        secondary: colors.grey.darken3,
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.orange.darken1,

        workspace: colors.blueGrey.lighten3
      },
      dark: {
        primary: colors.blue,
        secondary: colors.grey.darken3,
        accent: colors.pink.accent2,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.orange.darken1
      }
    }
  },
  lang: {
    locales: { ja },
    current: 'ja'
  },
  icons: {
    iconfont: 'md'
  }
})
